import {Img, Link, Tooltip} from '@chakra-ui/react';
import React from 'react';
import {useResponsive} from 'utils/useResponsive';
import {statusIconNav} from './hooks';
import {useRouter} from 'next/router';
import NextLink from 'next/link';
import {RouteNames} from 'modules/navigation';
import {useLocalizedNavigation} from 'modules/navigation/hooks';

export interface GeoIconDefaultProps {
	link?: RouteNames;
	src?: string;
	extended?: boolean;
	label?: string;
}

export const GeoIconDefault: React.FC<GeoIconDefaultProps> = ({
	link,
	src,
	label,
	extended
}: GeoIconDefaultProps) => {
	const {isMobile} = useResponsive();
	const [status, setStatus] = React.useState<statusIconNav>('inactive');
	const router = useRouter();
	const isCurrentPath = router.pathname.includes(link);
	const renderStatus = () => {
		switch (status) {
			case 'hover':
				return `/images/${src}-hover.svg`;
			default:
				return `/images/${src}.svg`;
		}
	};
	const {getPath} = useLocalizedNavigation();

	return (
		<NextLink passHref href={getPath(link, false)}>
			<Link
				sx={{_focus: {outline: 0}}}
				onMouseEnter={() => setStatus('hover')}
				onMouseOut={() => setStatus('inactive')}
			>
				<Tooltip
					label={label}
					placement={isMobile ? 'top' : 'right'}
					hasArrow
					isDisabled={!label}
				>
					<Img
						src={isCurrentPath ? `/images/${src}-active.svg` : renderStatus()}
						height={isMobile ? '4rem' : '3.1em'}
						minHeight='50px'
						maxHeight='60px'
						width={isMobile ? '2rem' : '3em'}
						minWidth='50px'
						maxWidth='60px'
						alt={label}
					/>
				</Tooltip>
			</Link>
		</NextLink>
	);
};
